<template>
  <div class="rainbow-cup">
    <div class="mask"></div>
    <img
      class="image-1"
      @load="bindImageLoad"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f358f750f78a3c69a1a30cfb702e7284.png"
      alt=""
    />
    <div class="ripple-content" v-if="data.length">
      <div
        class="ripple-box"
        id="ripple-content"
        :style="{
          height: curHeight + '%',
          transitionDuration: (curStatus - oldStatus) * anmationTime + 's'
        }"
      >
        <div class="ripple" v-if="imageLoaed">
          <div
            class="ripple-item"
            :class="['item-' + (rippleindex + 1)]"
            v-for="(rippleitem, rippleindex) in 3"
            :key="rippleindex"
          >
            <img
              class="ripple-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/98ca3d1f8c6116466f9bac0b51ecf14f.png"
              alt=""
            />
            <div class="ripple-bottom"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { config } from '../data'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      anmationTime: config.anmationTime,
      oldStatus: 0, //之前的状态
      imageLoaed: false, // 空瓶是否加载完成
      colorList: [],
      curStatus: 0,
      totalCount: 9 //总格子数
    }
  },
  watch: {
    data(val) {
      this.curStatus = this.status
      this.initColor(val)
    },
    status(val, oldval) {
      this.oldStatus = oldval
      setTimeout(() => {
        this.curStatus = val
      }, 300)
    }
  },
  computed: {
    curHeight() {
      let total = this.data.reduce((pre, cur) => {
        return pre + cur.water_volume
      }, 0)
      let drinkVolume = 0
      let len = this.data.length - this.status
      for (let i = 0; i < len; i++) {
        drinkVolume += this.data[i].water_volume
      }
      let cur = ((total - drinkVolume) / total) * 100
      if (cur < 0) {
        cur = 0
      } else if (cur > 100) {
        cur = 100
      }
      return parseFloat(cur.toFixed(2))
    }
  },
  created() {
    this.initColor(this.data)
  },
  methods: {
    bindImageLoad() {
      this.imageLoaed = true
    },
    initColor(data) {
      let res = data.map((item) => {
        return item
      })
      let number = this.totalCount
      if (res.length < number) {
        let num = number - res.length
        for (let i = 0; i < num; i++) {
          res.unshift({
            water_color: 'rgba(0,0,0,0)'
          })
        }
      }
      this.colorList = res
    }
  }
}
</script>
<style lang="scss" scoped>
.rainbow-cup {
  width: 188px;
  height: 100%;
  z-index: 10;
  position: relative;

  .mask {
    background: #ffffff;
    filter: blur(20px);
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 260px;
    object-fit: contain;
    z-index: -1;
  }

  .image-1 {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 10;
  }

  .color-container {
    position: absolute;
    width: 100%;
    height: 282px;
    border-radius: 63px 63px 70px 70px;
    left: 0;
    bottom: 0;
    z-index: 8;
    overflow: hidden;
    display: flex;
    align-items: flex-end;

    .color-mask {
      width: 100%;
      height: 0%;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
      transition: height 0.3s linear;
    }

    .color-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      height: 282px;

      .color-item {
        flex: 1;
        display: flex;
        align-items: flex-end;

        .color {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .ripple-content {
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 295px;
    left: 0;
    bottom: 0;
    border-radius: 60px;
    overflow: hidden;
    display: flex;
    align-items: flex-end;

    .ripple-box {
      width: 100%;
      height: 100%;
      transition: height 0.6s linear 0.5s;
    }

    .ripple {
      position: relative;
      width: 100%;
      height: 100%;
      animation: cupmove 4s linear infinite;

      .ripple-item {
        position: absolute;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        left: 0%;
        width: 300%;
        height: 100%;
        transform: translate(-33.33%, 0%);
        animation: inherit;
        top: 0%;

        .ripple-image {
          width: 100%;
          display: block;
          object-fit: contain;
        }

        .ripple-bottom {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          background-color: rgb(146, 235, 254);
        }
      }

      .item-1 {
        animation-duration: 5s;
      }

      .item-2 {
        animation-duration: 7s;
      }

      .item-3 {
        animation-duration: 9s;
      }
    }
  }
}

@keyframes cupmove {
  0% {
    transform: translate(-33.33%, 0%);
  }

  100% {
    transform: translate(0%, 0%);
  }
}
</style>
